var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainSelected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0798 15.7198C18.4898 12.1898 15.0998 9.31982 11.5198 9.31982C7.62979 9.31982 4.20979 12.4698 3.87979 16.3498C3.74979 17.8498 4.22979 19.2698 5.21979 20.3398C6.19979 21.4098 7.57979 21.9998 9.07979 21.9998H13.7598C15.4498 21.9998 16.9298 21.3398 17.9398 20.1498C18.9498 18.9598 19.3498 17.3798 19.0798 15.7198Z",
    fill: "#D03660"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2801 7.86C11.8983 7.86 13.2101 6.54819 13.2101 4.93C13.2101 3.31181 11.8983 2 10.2801 2C8.6619 2 7.3501 3.31181 7.3501 4.93C7.3501 6.54819 8.6619 7.86 10.2801 7.86Z",
    fill: "#D03660"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.94 9.0299C18.2876 9.0299 19.38 7.93748 19.38 6.5899C19.38 5.24233 18.2876 4.1499 16.94 4.1499C15.5924 4.1499 14.5 5.24233 14.5 6.5899C14.5 7.93748 15.5924 9.0299 16.94 9.0299Z",
    fill: "#D03660"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5501 12.9298C21.6271 12.9298 22.5001 12.0567 22.5001 10.9798C22.5001 9.90283 21.6271 9.02979 20.5501 9.02979C19.4731 9.02979 18.6001 9.90283 18.6001 10.9798C18.6001 12.0567 19.4731 12.9298 20.5501 12.9298Z",
    fill: "#D03660"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94 10.9801C5.28757 10.9801 6.38 9.88767 6.38 8.5401C6.38 7.19252 5.28757 6.1001 3.94 6.1001C2.59243 6.1001 1.5 7.19252 1.5 8.5401C1.5 9.88767 2.59243 10.9801 3.94 10.9801Z",
    fill: "#D03660"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainSelected);
export default __webpack_public_path__ + "static/media/main_selected.9862ecccf7eb723f6853b41a46ad89bd.svg";
export { ForwardRef as ReactComponent };